// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"933c7b17","216":"583d417e","232":"e09d5d6e","264":"7fa6349e","320":"99cdf790","335":"6c9a0c39","445":"9b213bee","478":"e2264d00","518":"25e733dd","735":"3479b374","974":"62eaaf8f","982":"76c5c882"}[chunkId] + ".chunk.js";
};